// Dono: B3. Chave "Privado" do detalhe (Detail.tsx monta): liga/desliga a etiqueta reservada "privado".
import { useId } from "preact/hooks";
import type { Card } from "../../../../shared/types.ts";
import { failed, store, toast } from "../state.ts";
import { IconLock } from "./icons.tsx";

export const PRIVATE_NOTE = "Some da grade, da busca e do Reencontro; aparece só buscando #privado. Não é criptografia: quem entra na sua conta ainda vê.";

export function PrivateToggle({ card }: { card: Card }) {
  const id = useId();
  return (
    <div class="private-row">
      <label class="switch">
        <input
          type="checkbox"
          role="switch"
          checked={card.isPrivate}
          aria-describedby={`${id}-n`}
          onChange={(e) => {
            const on = e.currentTarget.checked;
            store.setPrivate(card.id, on).then(() => toast({ key: `priv:${card.id}:${on}`, text: on ? "Card agora é privado." : "Card voltou a aparecer em tudo." }), failed);
          }}
        />
        <span class="switch-track" aria-hidden="true" />
        <IconLock />
        Privado
      </label>
      <p id={`${id}-n`} class="private-note">
        {PRIVATE_NOTE}
      </p>
    </div>
  );
}
